import React from "react";
import i18n from "i18next";

/* eslint-disable react/prop-types */

export default function EndScreen({ onRestart }) {
  return (
    <div className="sce-endscreen">
      <div className="sce-endscreen__icon" aria-hidden="true">
        ✅
      </div>
      <h2 className="sce-endscreen__title">
        {i18n.t("InteractiveScenario.EndScreen.Title") || "İnteraktif tamamlandı"}
      </h2>
      {onRestart && (
        <button
          type="button"
          className="sce-btn sce-btn--secondary sce-endscreen__restart"
          onClick={onRestart}
        >
          {i18n.t("InteractiveScenario.EndScreen.Restart") || "Baştan Başla"}
        </button>
      )}
    </div>
  );
}
